import type { Messages } from "@/i18n/locales/en";
import { legalMessagesTr } from "@/i18n/locales/legalTrData";
import { pagesMessagesTr } from "@/i18n/locales/pagesTrData";

export const trMessages = {
  meta: {
    description:
      "WasOK — ürünleri tarayın, puanları ve notları kaydedin, alınmaya değer olanları hatırlayın.",
    title: "WasOK — Alınmaya değer olanı hatırlayın",
  },
  header: {
    navFeatures: "Özellikler",
    navHowItWorks: "Nasıl çalışır",
    navPrivacy: "Gizlilik",
    navUseCases: "Kullanım alanları",
    download: "İndir",
    openMenu: "Menüyü aç",
    closeMenu: "Menüyü kapat",
    languageAria: "Dil",
  },
  hero: {
    badge: "📱 Artık Android'de mevcut",
    title: "Alınmaya değer olanı hatırlayın.",
    subtitle:
      "Ürünleri tarayın, puanları ve notları kaydedin — bir ürünün gerçekten iyi olup olmadığını anında hatırlayın.",
    googlePlay: "Google Play'den indirin",
    watchDemo: "Demoyu izle",
    privacyLine: "Tüm veriler cihazınızda kalır.",
    phoneTitle: "WasOK",
    phoneSubtitle: "Hatırlamak için tara",
    snackCard: "Lezzetli!",
    coffeeCard: "Çok acı",
    scrollHint: "Keşfetmek için kaydırın",
  },
  problems: {
    heading: "Tanıdık geliyor mu?",
    subheading:
      "Hepimiz yaşadık — rafların önünde durup geçen sefer beğenip beğenmediğimizi hatırlamaya çalışmak.",
    notedAgo: "✓ Bunu 3 ay önce not ettiniz",
    items: [
      {
        question: "Hangi çikolatayı gerçekten beğenmiştim?",
        note: "Tam kıvamında tatlı",
      },
      {
        question: "Bu şampuanı neden almaktan vazgeçtim?",
        note: "Saçlarımı kuruttu",
      },
      {
        question: "Bu kahve iyi miydi yoksa hayal kırıklığı mı?",
        note: "Çok acı",
      },
    ],
  },
  howItWorks: {
    heading: "Nasıl çalışır",
    subheading:
      "Ürün görüşlerinizi bir daha unutmamak için dört basit adım.",
    stepPrefix: "Adım",
    steps: [
      {
        title: "Herhangi bir ürün barkodunu tarayın",
        description:
          "Kameranızla hızlı ve kolay tarama. Her barkodla çalışır.",
      },
      {
        title: "Puanları, yorumları ve fotoğrafları kaydedin",
        description:
          "Ürünleri puanlayın, not ekleyin, fotoğraf ekleyin, fiyat ve konum kaydedin.",
      },
      {
        title: "Deneyiminizi anında hatırlayın",
        description:
          "Aynı ürünü sonra tarayın ve önceki puanınızı ile notlarınızı görün.",
      },
      {
        title: "Akıllı alışveriş listeleri oluşturun",
        description:
          "Zaten güvendiğiniz ve sevdiğiniz ürünlerden alışveriş listeleri oluşturun.",
      },
    ],
  },
  privacy: {
    heading: "Alışveriş geçmişiniz size ait kalır.",
    body: "WasOK, denediğiniz ürünleri hatırlamanıza yardımcı olur; puanlarınız, notlarınız, fotoğraflarınız ve alışveriş listeleriniz cihazınızda yerel olarak saklanır.",
    trustBanner:
      "💚 Alışveriş geçmişiniz etrafında tasarlandı — verilerinizi toplamak için değil.",
    bullets: [
      "Hesap gerekmez",
      "Bulut senkronizasyonu gerekmez",
      "Yerel öncelikli depolama",
      "Kullanıcı kontrollü yedekler",
      "Ürün bilgisi için isteğe bağlı barkod araması.",
      "Google AdMob ile reklam destekli",
    ],
  },
  features: {
    heading: "İhtiyacınız olan her şey",
    subheading:
      "Ürün takibini basit ve özel kılmak için tasarlanmış güçlü özellikler.",
    items: [
      {
        title: "Barkod Tarayıcı",
        description: "Her ürün için hızlı ve doğru barkod tarama.",
      },
      {
        title: "Ürün Puanları",
        description: "Kaliteyi hatırlamak için ürünleri 1–5 yıldızla puanlayın.",
      },
      {
        title: "Ürün Fotoğrafları",
        description: "Ambalajı veya ayrıntıları hatırlamak için fotoğraf ekleyin.",
      },
      {
        title: "Kategoriler",
        description: "Ürünleri özel kategorilere ayırın.",
      },
      {
        title: "Mağaza Takibi",
        description: "Her ürünü nereden aldığınızı hatırlayın.",
      },
      {
        title: "Fiyat Kaydı",
        description: "En iyi fırsatları bulmak için fiyatları takip edin.",
      },
      {
        title: "Alışveriş Listeleri",
        description: "Favori ürünlerinizden listeler oluşturun.",
      },
      {
        title: "Çevrimdışı Erişim",
        description: "İnternet bağlantısı olmadan mükemmel çalışır.",
      },
      {
        title: "Yerel Depolama",
        description: "Tüm verileriniz cihazınızda güvenle saklanır.",
      },
    ],
  },
  useCases: {
    heading: "Her reyon için ideal",
    subheading:
      "Gıda, güzellik veya ev ürünleri alışverişi — WasOK hatırlamanıza yardımcı olur.",
    cards: [
      {
        emoji: "🍫",
        title: "Atıştırmalıklar ve Tatlılar",
        description: "Hangi şekerlemelerin gerçekten iyi olduğunu hatırlayın.",
      },
      {
        emoji: "☕",
        title: "Kahve ve İçecekler",
        description: "Tekrar alınmaya değer kahveleri takip edin.",
      },
      {
        emoji: "💄",
        title: "Kozmetik ve Cilt Bakımı",
        description: "Cilt tepkileri hakkında not tutun.",
      },
      {
        emoji: "🧹",
        title: "Ev Ürünleri",
        description: "Başarısız ürünleri yeniden almaktan kaçının.",
      },
    ],
  },
  screenshots: {
    heading: "Güzel ve sezgisel",
    subheading:
      "Ürün takibini keyifli hale getiren özenle tasarlanmış bir arayüz.",
    items: [
      { title: "Tarayıcı" },
      { title: "Ürün Detayı" },
      { title: "Puan Girişi" },
      { title: "Arama ve Geçmiş" },
      { title: "Alışveriş Listesi" },
    ],
  },
  cta: {
    heading: "Gerçek hayat için alışveriş hafızası.",
    body: "Hangi ürünlerin alınmaya değer olduğunu unutmayı bırakın. Bugün daha akıllı alışveriş yapın.",
    googlePlay: "Google Play'den indirin",
    scanQr: "İndirmek için tarayın",
    tagline: "Özel · Çevrimdışı öncelikli · Basit",
  },
  footer: {
    tagline: "Alınmaya değer olanı hatırlayın.",
    linksHeading: "Bağlantılar",
    privacyPolicy: "Gizlilik Politikası",
    terms: "Hizmet Şartları",
    contact: "İletişim",
    linkFaq: "SSS",
    linkLicenses: "Açık Kaynak Lisansları",
    linkAdvertising: "Reklam ve Monetizasyon",
    downloadHeading: "İndir",
    googlePlay: "Google Play",
    copyright:
      "© 2026 WasOK. Tüm hakları saklıdır. Daha akıllı alışveriş için 💚 ile yapıldı.",
  },
  legal: legalMessagesTr,
  faq: pagesMessagesTr.faq,
  support: pagesMessagesTr.support,
  advertising: pagesMessagesTr.advertising,
} satisfies Messages;
